export default [{
  id: 1,
  title: 'Киоск Lazer Mini 19',
  description_short: 'FullHD, Intel Pentium Gold, SSD 120 Гб, 4 Гб DDR4, USB 3.0 / USB 2.0 / RJ-45 / AUX / HDMI, Мощный Wi-Fi адаптер, Система охлаждения, Windows 10 Pro',
  description: 'Проверенное качество и эргономика, обеспечивающее высокое удобство взаимодействия с киоском. Экономное решение, с легкостью расширяемое дополнительным оборудованием - от сканера штрих-кодов до антивандальной клавиатуры.',
  price: 109000,
  slug: 'lazer',
  category: 'kiosks',
  img: require('@/assets/img/bmgroup/lazer-19.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 19 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 19 до 32 дюймов'
  }]
}, {
  id: 2,
  title: 'Киоск Helper 43',
  description_short: 'FullHD, Intel Core i3, 8 Гб DDR4, SSD 250 Гб, ИК-рамка до 10 одновременных касаний, Мощный Wi-Fi адаптер, Система охлаждения, Windows 10 Pro',
  description: 'Доступное и эффективное решения для информационного киоска - обеспечит получение информации и получение услуг всеми категориями граждан для любого учреждения.',
  price: 225000,
  slug: 'helper',
  category: 'kiosks',
  img: require('@/assets/img/bmgroup/helper-43.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 43 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i3'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 250 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 65 дюймов'
  }]
}, {
  id: 3,
  title: 'Киоск Genius 43',
  description_short: 'FullHD, Intel Core i3, SSD 250 Гб, 8 Гб DDR4, USB 3.0 / USB 2.0 / RJ-45 / AUX / HDMI, Мощный Wi-Fi адаптер, Система охлаждения, Windows 10 Pro',
  description: 'Киоск с альбомной ориентацией дисплея. Форм-фактор и угол наклона обеспечивают удобство использования киоска конечными пользователями, при этом киоск занимает миниум места в помещении.',
  price: 175000,
  slug: 'genius',
  category: 'kiosks',
  img: require('@/assets/img/bmgroup/genius.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 43 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i3'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 250 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 4,
  title: 'Киоск BLACKGLASS+ PREMIUM 55',
  description_short: '4K UHD, ИК-рамка до 10 одновременных касаний, Intel Core i3, SSD 250 Гб, 8 Гб DDR4, Мощный Wi-Fi адаптер, Система охлаждения, Windows 10 Pro',
  description: 'Киоск, выполненный в классическом стиле и привычном форм-факторе. Идеально вписывается в любое пространство, легко расширяется дополнительным оборудованием, обладает высокой производительностью.',
  price: 240000,
  slug: 'blackglass',
  category: 'kiosks',
  img: require('@/assets/img/bmgroup/blackglass-premium.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 55 дюймов с разрешением 4K UHD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i5'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 250 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 75 дюймов'
  }]
}, {
  id: 5,
  title: 'Киоск Super Star Premium 50"',
  description_short: '4K UHD, Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i5, SSD 500 Гб, 8 Гб DDR4, Мощный Wi-Fi адаптер, Система охлаждения, Windows 10 Pro',
  description: 'Превосходный внешний вид и дизайн в совокупности с продвинутым техническим оснащением делает киоск супервездой в своей нише - киоск справляется с любой интерактивной задачей и легко расширяется дополнительным оборудованием',
  price: 327000,
  slug: 'superstar',
  category: 'kiosks',
  img: require('@/assets/img/bmgroup/superstar.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 50 дюймов с разрешением 4K UHD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i5'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 500 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 75 дюймов'
  }]
}, {
  id: 6,
  title: 'Киоск STREET 43"',
  description_short: 'Диагональ 43 дюйма с разрешением Full HD и яркостью 2000 кд/ м², Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i3, SSD 250 Гб, 8 Гб DDR4, Windows 10 Pro',
  description: 'Надежное решение для общественных мест - антивандальный корпус, умная система климат-контроля и производительное железо обеспечивает бесперебойную работу киоска в любых погодных условиях.',
  price: 335000,
  slug: 'street',
  category: 'kiosks-street',
  img: require('@/assets/img/bmgroup/street-43.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 43 дюйма с разрешением Full HD и яркостью 2000 кд/ м²'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i3'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 250 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 75 дюймов'
  }]
}, {
  id: 7,
  title: 'Киоск STREET PREMIUM 55"',
  description_short: 'Диагональ 55 дюймов с разрешением Full HD и яркостью 2000 кд/ м², Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i5, SSD 250 Гб, 8 Гб DDR4, Windows 10 Pro',
  description: 'Надежное решение для общественных мест - антивандальный корпус, умная система климат-контроля и производительное железо обеспечивает бесперебойную работу киоска в любых погодных условиях.',
  price: 440000,
  slug: 'street-55',
  category: 'kiosks-street',
  img: require('@/assets/img/bmgroup/street-55.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 55 дюймов с разрешением 4K UHD и яркостью 2000 кд/ м²'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Core i5'
  }, {
    name: 'Оперативная память',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 250 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 75 дюймов'
  }]
}, {
  id: 8,
  title: 'Киоск двусторонний Street Duo Premium "',
  description_short: 'Двусторонний киоск, Диагональ 55 дюймов с разрешением Full HD и яркостью 2000 кд/ м², Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i5, SSD 250 Гб, 8 Гб DDR4, Windows 10 Pro',
  description: 'Эффективное решение для общественных мест с высокой проходимостью. Благодаря двустороннему корпусу устройством могут пользоваться одновременно два человека.',
  price: 809000,
  slug: 'street-duo',
  category: 'kiosks-street',
  img: require('@/assets/img/bmgroup/street-duo.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей (х2)',
    value: 'Диагональ 55 дюймов с разрешением 4K UHD и яркостью 2000 кд/ м²'
  }, {
    name: 'Тип сенсора (х2)',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор (х2)',
    value: 'Intel Core i5'
  }, {
    name: 'Оперативная память (х2)',
    value: '8 Гб DDR4'
  }, {
    name: 'Жесткий диск (х2)',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема (х2)',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 75 дюймов'
  }]
}, {
  id: 9,
  title: 'Киоск BG Legend 43" (с рекламным экраном)',
  description_short: 'Рекламный экран 24 дюйма Full HD яркость 1500, основной - Диагональ 43 дюйма с разрешением Full HD и яркостью 2000 кд/ м², Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i3, SSD 250 Гб, 8 Гб DDR4, Windows 10 Pro',
  description: 'Функциональное решение с возможностью двойного взаимодействия с пользователями за счет дополнительного рекламного экрана. Антивандальное исполнение, умная система климат-контроля обеспечивают надежную работу киоска в режиме 24/7 в любых погодных условиях.',
  price: 399000,
  slug: 'legend',
  category: 'kiosks-street',
  img: require('@/assets/img/bmgroup/legend.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 19 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 19 до 32 дюймов'
  }]
}, {
  id: 10,
  title: 'Киоск STREET GLASS PREMIUM 55"',
  description_short: 'Диагональ 55 дюймов с разрешением 4K UHD и яркостью 2000 кд/ м², Проекционно-емкостная технология до 10 одновременных касаний, Intel Core i5, SSD 250 Гб, 8 Гб DDR4, Windows 10 Pro',
  description: 'Интерактивный уличный киоск Street Glass - это классическое сенсорное устройство для навигации на открытом воздухе. Street Glass может быть стилизован под концепцию парка с помощью брендирования фасадного стекла киоска или нестандартной подсветки корпуса.',
  price: 450000,
  slug: 'street-glass',
  category: 'kiosks-street',
  img: require('@/assets/img/bmgroup/street-glass.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 19 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 19 до 32 дюймов'
  }]
}, {
  id: 11,
  title: 'Терминал Base',
  description_short: 'Диагональ 24 дюйма Full HD, проекционно-емкостная технология до 10 одновременных касаний, процессор Intel NUC, 4 Гб DDR4, 120 GB SSD, Подготовка под установку POS-терминала, Фискальный накопитель: Казначей ФА',
  description: 'Простое базовое решение для внедрения самообслуживания клиентов на любое предприятие. Термопринтер, подготовка под POS-терминал, фискальный регистратор и производительное железо - все, что необходимо для старта.',
  price: 139000,
  slug: 'base',
  category: 'terminals',
  img: require('@/assets/img/bmgroup/base.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 24 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel NUC'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Фискальный накопитель',
    value: 'Казначей ФА'
  }, {
    name: 'Внешние разъемы (стандарт)',
    value: 'RJ-45'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 24 до 32 дюймов'
  }]
}, {
  id: 12,
  title: 'Двусторонний терминал самообслуживания SKALA',
  description_short: '32 дюйма Full HD, проекционно-емкостная технология до 10 одновременных касаний, процессор Intel NUC, 4 Гб DDR4, 120 GB SSD, Подготовка под установку POS-терминала, Фискальный накопитель: Казначей ФА',
  description: 'Двусторонний терминал самообслуживания с компактным форм-фактором обеспечит высокую пропускную способность точки продаж, а производительное железо и программное обеспечение позволят сформировать положительный пользовательский опыт у ваших клиентов',
  price: 310000,
  slug: 'skala',
  category: 'terminals',
  img: require('@/assets/img/bmgroup/skala.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel NUC'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Фискальный регистратор',
    value: 'Казначей ФА'
  }, {
    name: 'Внешние разъемы (стандарт)',
    value: 'RJ-45'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 13,
  title: 'Nautilus L',
  description_short: '32 дюйма Full HD, проекционно-емкостная технология до 10 одновременных касаний, процессор Intel NUC, 4 Гб DDR4, 120 GB SSD, Подготовка под установку POS-терминала, Фискальный накопитель: Казначей ФА',
  description: 'Терминал исполнен в эргономичном тонком корпусе и рассчитан на максимально комфортное взаимодействие с пользователем. Терминал оснащается ярким сенсорным экраном, мощным вычислительным блоком, картоприемником и термопринтером, благодаря чему пользователь может с удобством выбрать понравившийся товар, моментально оплатить заказ и получить чек.',
  price: 185000,
  slug: 'nautilus',
  category: 'terminals',
  img: require('@/assets/img/bmgroup/nautilus.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel NUC'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Фискальный регистратор',
    value: 'Казначей ФА'
  }, {
    name: 'Внешние разъемы (стандарт)',
    value: 'RJ-45'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 14,
  title: 'Sirocco Retail',
  description_short: '24 дюйма Full HD, проекционно-емкостная технология 10 одновременных касаний, Intel NUC Celeron, 4ГБ DDR4, SSD 120 ГБ, полный набор оборудования для реализации процесса продажи',
  description: 'Терминал позволяющий автоматизировать процесс самообслуживания оплаты товара в магазинах розничной торговли и обеспечивает прием платежей с помощью контактного и бесконтактного вида оплаты. Благодаря встроенному термопринтеру пользователь моментально получает чек о покупке. Напольное исполнение, надежный стальной корпус позволяют оборудованию вписаться в любое пространство',
  price: 128000,
  slug: 'sirocco',
  category: 'terminals',
  img: require('@/assets/img/bmgroup/sirocco.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 19 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 19 до 32 дюймов'
  }]
}, {
  id: 15,
  title: 'Nautilus L Street',
  description_short: '32 дюйма Full HD, проекционно-емкостная технология до 10 одновременных касаний, процессор Intel NUC, 4 Гб DDR4, 120 GB SSD, Подготовка под установку POS-терминала, Фискальный накопитель: Казначей ФА',
  description: 'Уличный платежный терминал Nautilus L Street исполнен в эргономичном, всепогодном корпусе. Благодаря устройству пользователь может с удобством выбрать понравившийся товар, моментально оплатить заказ и получить чек.',
  price: 499000,
  slug: 'nautilus-street',
  category: 'terminals',
  img: require('@/assets/img/bmgroup/nautilus-street.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel NUC'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Фискальный регистратор',
    value: 'Казначей ФА'
  }, {
    name: 'Внешние разъемы (стандарт)',
    value: 'RJ-45'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 16,
  title: 'Интерактивный стол Atom',
  description_short: '32 дюйма FullHD, ИК-рамка на 10 одновременных касаний, AMD Athlon, 4 Гб DDR4, SSD 120 Гб, Windows 10 IoT',
  description: 'Эргономичный интерактивный стол, выполненный из композитного аллюминия - надежное решение и современный дизайн',
  price: 188000,
  slug: 'atom',
  category: 'tables',
  img: require('@/assets/img/bmgroup/atom.png'),
  params: [{
    name: 'Материал',
    value: 'Композитный аллюминий'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка на 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'AMD Athlon'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 IoT'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 17,
  title: 'CЕНСОРНЫЙ СТОЛ PROTOTYPE GLASS',
  description_short: '32 дюйма FullHD, Проекционно-ёмкостная технология на 10 одновременных касаний, AMD Athlon, 4 Гб DDR4, SSD 120 Гб, Windows 10 IoT',
  description: 'Премиальный сенсорный стол с глянцевой стеклянной лицевой поверхностью. Корпус защищен от внешних воздействий, при этом обладая притягивающим взгляды посетителей дизайном',
  price: 169000,
  slug: 'prototype-glass',
  category: 'tables',
  img: require('@/assets/img/bmgroup/prototype-glass.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюйма с разрешением FullHD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'AMD Athlon'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 IoT'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 18,
  title: 'Сенсорный стол Snake',
  description_short: '32 дюйма с разрешением FullHD, ИК-рамка на 10 одновременных касаний, AMD Athlon, 4 Гб DDR4, SSD 120 Гб, Windows 10 IoT, Механическая регулировка угла наклона экрана (90 градусов)',
  description: 'Интерактивный стол Snake – универсальное решение для любого пространства. Он отлично подойдет, как для образовательного учреждения, так и для выставочного стенда.',
  price: 142000,
  slug: 'snake',
  category: 'tables',
  img: require('@/assets/img/bmgroup/snake.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка на 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'AMD Athlon'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 IoT'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 19,
  title: 'Сенсорный поворотный стол Slider 43"',
  description_short: '43 дюйма с разрешением FullHD, Проекционно-ёмкостная технология на 10 одновременных касаний, AMD Athlon, 4 Гб DDR4, SSD 120 Гб, Windows 10 IoT, Автоматическая регулировка угла наклона экрана, автоматическая регулировка высоты',
  description: 'Возможность автоматического изменения высоты стола и угла наклона экрана до полностью вертикального положения делают стол Slider многофункциональным мультимедийным устройством для широкого применения.',
  price: 315000,
  slug: 'slider',
  category: 'tables',
  img: require('@/assets/img/bmgroup/slider.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 19 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-емкостная технология до 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 19 до 32 дюймов'
  }]
}, {
  id: 20,
  title: 'ИНТЕРАКТИВНЫЙ СЕНСОРНЫЙ СТОЛ W-CLASS',
  description_short: 'Диагональ 32 дюйма с разрешением Full HD, ИК-рамка на 10 одновременных касаний, Intel Pentium Gold, 4 Гб DDR4, SSD 120 Гб, Windows 10 Pro',
  description: 'Неповторимый дизайн, антивандальные материалы производства и богатый функционал, которые превращают интерактивный стол W-Class в мощный инструмент взаимодействия с клиентом, способный  автоматизировать бизнес процессы и повысить эффективность',
  price: 173000,
  slug: 'w-class',
  category: 'tables',
  img: require('@/assets/img/bmgroup/w-class.png'),
  params: [{
    name: 'Материал',
    value: 'Композитный алюминий'
  }, {
    name: 'Дисплей',
    value: 'Диагональ 32 дюймов с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'ИК-рамка на 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 32 до 55 дюймов'
  }]
}, {
  id: 21,
  title: 'ГОЛОГРАФИЧЕСКИЙ КУБ WIZARD 24"',
  description_short: '24 дюйма с разрешением Full HD, медиаплеер, возможность подсветки, брендирования и дополнительного оснащения. Опционально - разработка контента.',
  description: 'Голографический куб Wizard идеально подходит для дополнения реального объекта какой-либо информацией, а также статичной или анимированной 3D графикой.',
  price: 95000,
  slug: 'wizard',
  category: 'presentations',
  img: require('@/assets/img/bmgroup/wizard.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь, стекло'
  }, {
    name: 'Дисплей',
    value: '24 дюйма с разрешением Full HD'
  }, {
    name: 'Дополнительно',
    value: 'Медиаплеер'
  }, {
    name: 'Процессор',
    value: 'Intel Core i3/i5/i7'
  }, {
    name: 'Оперативная память',
    value: 'До 64 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD объёмом до 1 ТБ'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 24 до 43 дюймов'
  }]
}, {
  id: 22,
  title: 'ГОЛОГРАФИЧЕСКАЯ ПИРАМИДА VISION 24"',
  description_short: '24 дюйма с разрешением Full HD, медиаплеер, возможность подсветки, брендирования и дополнительного оснащения. Опционально - разработка контента.',
  description: 'Благодаря специальной технологии плоское изображение превращается в 3D-голограмму, которая может вращаться, меняться и исчезать. Голографическую пирамиду можно дополнить специальной подставкой на колесиках с фиксаторами для удобства ее перемещения.',
  price: 87000,
  slug: 'vision',
  category: 'presentations',
  img: require('@/assets/img/bmgroup/vision.png'),
   params: [{
    name: 'Материал',
    value: 'Сталь, стекло'
  }, {
    name: 'Дисплей',
    value: '24 дюйма с разрешением Full HD'
  }, {
    name: 'Дополнительно',
    value: 'Медиаплеер'
  }, {
    name: 'Процессор',
    value: 'Intel Core i3/i5/i7'
  }, {
    name: 'Оперативная память',
    value: 'До 64 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD объёмом до 1 ТБ'
  }, {
    name: 'Аудиосистема',
    value: 'Встроенная 2х5 Вт'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 24 до 43 дюймов'
  }]
}, {
  id: 23,
  title: '3D ГОЛОГРАФИЧЕСКАЯ ПИРАМИДА VOSTORG 24"',
  description_short: '24 дюйма с разрешением Full HD, медиаплеер, возможность подсветки, брендирования и дополнительного оснащения. Опционально - разработка контента.',
  description: 'Благодаря встроенному в основание дисплею пользователь может сам выбирать модель, которая будет отображаться внутри граней 3D пирамиды Vostorg. Стильный корпус, взаимодействие посетителя с контентом, эффект 3D-присутствия идеальны для блестящей презентации продукции или бренда.',
  price: 156000,
  slug: 'vostorg',
  category: 'presentations',
  img: require('@/assets/img/bmgroup/vostorg.png'),
  params: [{
    name: 'Материал',
    value: 'Сталь, стекло'
  }, {
    name: 'Дисплей x2',
    value: '24 дюйма с разрешением Full HD'
  }, {
    name: 'Тип сенсора',
    value: 'Проекционно-ёмкостная технология на 10 одновременных касаний'
  }, {
    name: 'Процессор',
    value: 'Intel Pentium Gold G5400'
  }, {
    name: 'Оперативная память',
    value: '4 Гб DDR4'
  }, {
    name: 'Жесткий диск',
    value: 'SSD 120 Гб'
  }, {
    name: 'Система охлаждения',
    value: 'Встроенная'
  }, {
    name: 'Операционная система',
    value: 'Windows 10 Pro'
  }, {
    name: 'Цвет',
    value: 'По каталогу RAL'
  }, {
    name: 'Диапазон диагоналей',
    value: 'от 24 до 43 дюймов'
  }]
}]
